export default __webpack_public_path__ + "static/Graphik-BoldItalic-Web-b3cab7b166e25ee0cd0d56589a145d98.ttf";